import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-beige" data-id="element-136" data-mp="30zb1160zu7tp">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-137" data-mp="2w5yaurgo1syu">
        <div className="text-center" data-id="element-138" data-mp="2w4eu6zr3lfwj">
          <h2 className="font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-139" data-mp="2r7ww2iq9wft6">
            Czy rozpoznajesz siebie w tych sytuacjach?
          </h2>
          <p className="mx-auto mt-3 max-w-md text-[12px] leading-relaxed text-muted" data-id="element-140" data-mp="2m5z5f3fjmiq7">
            Jeśli choć jedno z poniższych zdań brzmi znajomo — ten pakiet
            powstał dla Ciebie.
          </p>
        </div>

        <ul className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-3" data-id="element-141" data-mp="288sntc6k2q2k">
          {recognizeItems.map(item => <li key={item} className="flex w-full items-start gap-2.5 rounded-lg border border-ink/10 bg-white px-3.5 py-3 text-[11px] leading-snug text-muted sm:w-[calc(50%-0.375rem)]" data-id="element-142" data-mp="bf7o2iu8u0sn">
              <SparklesIcon className="mt-0.5 h-3 w-3 shrink-0 text-coral" aria-hidden="true" data-id="element-143" data-mp="3jjshr6ver9xr" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8 text-center" data-id="element-144" data-mp="39p0k631tsn2z">
          <a href="#zawartosc" className="group inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-coral transition-colors duration-150 ease-out hover:text-coral-dark" data-id="element-145" data-mp="3elh7ww544zfj">
            Zobacz, jak to zmienić
            <ArrowRightIcon className="h-3 w-3 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-146" data-mp="3sls2a95msw5g" />
          </a>
        </div>
      </div>
    </section>;
}